import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';
import { percentPrecision } from '@ideapa/common-utils';

export const ENTITY = 'partecipata';
export const ENTITY_PLURAL = 'anagrafe partecipate';

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Codice',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'codice',
    sortable: true,
    sort: 'asc',
    minWidth: 120,
    maxWidth: 150,
  },
  {
    elementLabel: 'Ragione Sociale',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'ragioneSociale',
    sortable: true,
  },
  {
    elementLabel: 'Codice Fiscale',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'codiceFiscale',
    sortable: true,
    minWidth: 250,
    maxWidth: 260,
  },
  {
    elementLabel: 'Partita IVA',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'partitaIva',
    initialHideColumn: true,
    sortable: true,
    minWidth: 250,
    maxWidth: 260,
  },
  {
    elementLabel: 'Sede Legale',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'sedeLegale',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Sito',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'sitoInternet',
    initialHideColumn: true,
  },
  {
    elementLabel: 'E-mail',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'email',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Pec',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pec',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Telefono',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'telefono',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Capitale Pubblico',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'swCapitalePubblico',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Quotata',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'swQuotata',
    initialHideColumn: true,
  },
  // {
  //   elementLabel: 'Data Acquisto',
  //   filterType: FilterType.date,
  //   fieldType: FieldType.date,
  //   field: 'enti.dataAcquisto',
  //   initialHideColumn: true,
  // },
  // {
  //   elementLabel: 'Data Cessazione',
  //   filterType: FilterType.date,
  //   fieldType: FieldType.date,
  //   field: 'enti.dataCessazione',
  //   initialHideColumn: true,
  // },
  {
    elementLabel: 'Data Costituzione',
    filterType: FilterType.date,
    fieldType: FieldType.date,
    field: 'dataCostituzione',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Numero Dipendenti',
    filterType: FilterType.number,
    fieldType: FieldType.integer,
    field: 'numeroDipendenti',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Capitale Sociale',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'capitaleSociale',
    initialHideColumn: true,
  },
  // {
  //   elementLabel: 'Stato Attivita',
  //   filterType: FilterType.boolean,
  //   fieldType: FieldType.boolean,
  //   field: 'statoAttivita',
  //   initialHideColumn: true,
  // },
  // {
  //   elementLabel: 'Disabilitato',
  //   filterType: FilterType.boolean,
  //   fieldType: FieldType.boolean,
  //   field: 'flagDis',
  //   initialHideColumn: true,
  // },
  {
    elementLabel: 'Descrizione Attività',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'descrizioneAttivita1',
    initialHideColumn: true,
  },
  {
    elementLabel: '% Possesso Totale',
    filterType: FilterType.number,
    fieldType: FieldType.percent,
    field: 'percentualePossessoTotale',
    sortable: false,
    hideFilter: true,
    contentAlignment: ContentAlignmentEnum.Right,
    precision: percentPrecision,
    minWidth: 250,
    maxWidth: 260,
  },
  // {
  //   elementLabel: 'Descrizione Attivita 2',
  //   filterType: FilterType.text,
  //   fieldType: FieldType.text,
  //   field: 'descrizioneAttivita2',
  //   initialHideColumn: true,
  // },
  // {
  //   elementLabel: 'Note',
  //   filterType: FilterType.text,
  //   fieldType: FieldType.text,
  //   field: 'note',
  //   initialHideColumn: true,
  // },
];

export const gridColumnsCU: EntityListField[] = [
  {
    elementLabel: 'Codice',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'codice',
    sortable: true,
    sort: 'asc',
    minWidth: 120,
    maxWidth: 150,
  },
  {
    elementLabel: 'Ragione Sociale',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'ragioneSociale',
    sortable: true,
  },
  {
    elementLabel: 'Codice Fiscale',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'codiceFiscale',
    sortable: true,
    minWidth: 250,
    maxWidth: 260,
  },
  {
    elementLabel: 'Partita IVA',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'partitaIva',
    initialHideColumn: true,
    sortable: true,
    minWidth: 250,
    maxWidth: 260,
  },
  {
    elementLabel: 'Sede Legale',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'sedeLegale',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Sito',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'sitoInternet',
    initialHideColumn: true,
  },
  {
    elementLabel: 'E-mail',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'email',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Pec',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pec',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Telefono',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'telefono',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Capitale Pubblico',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'swCapitalePubblico',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Quotata',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'swQuotata',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Data Costituzione',
    filterType: FilterType.date,
    fieldType: FieldType.date,
    field: 'dataCostituzione',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Numero Dipendenti',
    filterType: FilterType.number,
    fieldType: FieldType.integer,
    field: 'numeroDipendenti',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Capitale Sociale',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'capitaleSociale',
    initialHideColumn: true,
  },
  // {
  //   elementLabel: 'Stato Attivita',
  //   filterType: FilterType.boolean,
  //   fieldType: FieldType.boolean,
  //   field: 'statoAttivita',
  //   initialHideColumn: true,
  // },
  {
    elementLabel: 'Descrizione Attività',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'descrizioneAttivita1',
    initialHideColumn: true,
  },
];
export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
